const selectScales = (state) => state.responseScales.scales;
const selectIsLoading = (state) => state.responseScales.isLoading;

const responseScalesSelectors = {
  selectScales,
  selectIsLoading,
};

export default responseScalesSelectors;
